module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationFR.18e599cb.webp";